/**
 * CharacterWindows - 캐릭터 / 인벤토리 / 제작 / 월드맵 / 성향을 DAoC처럼 각각 독립된 창으로 제공한다.
 * 기존 CharacterSheetHUD(탭 1개 모달)의 인터페이스(openTab/toggle/...)를 그대로 유지하는 래퍼.
 */

import { EntityRegistry } from '../../core/EntityRegistry';
import { StableRouteSystem } from '../world/StableRouteSystem';
import { Settings } from '../../core/Settings';
import { CharacterSheetHUD, InspectorTab, SheetWindowCfg } from './CharacterSheetHUD';

const WINDOWS: SheetWindowCfg[] = [
  { key: 'character', title: '캐릭터 & 스킬', icon: '🧍', tabs: ['spec_skill', 'self_skill', 'personality', 'race_stat'], w: 600, h: 540, dx: 260, dy: 70 },
  { key: 'inventory', title: '인벤토리', icon: '🎒', tabs: ['inventory_20'], w: 740, h: 560, dx: 300, dy: 90 },
  { key: 'craft', title: '제작 & 인챈터', icon: '⚒️', tabs: ['craft_enchant'], w: 580, h: 500, dx: 340, dy: 110 },
  { key: 'map', title: '월드맵', icon: '🗺️', tabs: ['world_map'], w: 580, h: 540, dx: 380, dy: 70 },
];

export class CharacterWindows {
  private wins: Array<{ cfg: SheetWindowCfg; hud: CharacterSheetHUD }> = [];

  constructor(
    registry: EntityRegistry,
    onTeleportZone?: (zoneId: number) => void,
    stableRouteSystem?: StableRouteSystem
  ) {
    for (const cfg of WINDOWS) {
      this.wins.push({ cfg, hud: new CharacterSheetHUD(registry, onTeleportZone, stableRouteSystem, cfg) });
    }
  }

  public mount(parent: HTMLElement): void {
    for (const w of this.wins) w.hud.mount(parent);

    window.addEventListener('keydown', (e) => {
      if ((window as any).__TERRA_GAME_STATE__ && (window as any).__TERRA_GAME_STATE__() !== 'IN_WORLD') return;
      if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) return;
      const action = Settings.actionForKey(e.key);
      if (action === 'character') this.toggle('spec_skill');
      else if (action === 'inventory') this.toggle('inventory_20');
      else if (action === 'craft') this.toggle('craft_enchant');
      else if (action === 'map') this.toggle('world_map');
    });
  }

  private forTab(tab: InspectorTab): CharacterSheetHUD | undefined {
    return this.wins.find((w) => w.cfg.tabs.includes(tab))?.hud;
  }

  public toggle(tab: InspectorTab): void {
    this.forTab(tab)?.toggle(tab);
  }

  public openTab(tab: InspectorTab): void {
    this.forTab(tab)?.openTab(tab);
  }

  public openNpcInventory(npcId: string): void {
    this.forTab('inventory_20')?.openNpcInventory(npcId);
  }

  public refreshIfOpen(): void {
    for (const w of this.wins) w.hud.refreshIfOpen();
  }

  public setCurrentZoneId(zoneId: number): void {
    for (const w of this.wins) w.hud.setCurrentZoneId(zoneId);
  }
}
